/**
 * True while the user is typing in a text field, or working in a dialog (settings, calendar), so
 * game keys must not move the avatar.
 */
export function isTyping(): boolean {
  const element = document.activeElement;
  if (!(element instanceof HTMLElement)) return false;
  return (
    element.closest('[aria-modal="true"]') !== null ||
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement ||
    element.isContentEditable
  );
}
